<template>
  <div>
    <v-dialog v-model="dialog" max-width="1000" persistent>
      <v-card>
        <v-card-title>
          <back-button color="grey" @click="close" />
          Tipo do oligoelemento: {{ selectedType.name }}
        </v-card-title>
        <v-card-text>
          <span class="subtitle-1">Selecione o oligoelementos</span>
          <v-list three-line>
            <template v-for="element in selectedOligoelement">
              <step-item
                :key="element.id"
                :index="element.index"
                :title="element.name"
                :is-added="isAddedIntoDiagnosis(element)"
                class="elevation-2 mb-2 item-par"
                @click="selectOligoelement(element)"
              />
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <oligoelement />
  </div>
</template>

<script>
export default {
  name: "IndexDialog",
  components: {
    StepItem: () =>
      import("@/domains/therapy/shared/presentation/components/StepItem"),
    Oligoelement: () => import("./OligoelementDialog"),
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.dialogs.oligoelements.types;
      },
      set(value) {
        this.$store.commit("dialogs/setOligoelementsTypes", value);
      },
    },

    selectedType() {
      return this.$store.state.oligoelements.selectedType;
    },

    selectedOligoelement() {
      return this.$store.state.oligoelements.selectedType.oligoelements.map(
        (element, index) => ({
          ...element,
          index: index + 1,
        })
      );
    },
  },
  methods: {
    isAddedIntoDiagnosis(oligoelement) {
      return this.$store.state.diagnosis.diagnose.oligoelements.some(
        (item) => item.oligoelement.id === oligoelement.id
      );
    },
    close() {
      this.dialog = false;
    },
    selectOligoelement(oligoelement) {
      this.$store.commit("oligoelements/selectOligoelement", oligoelement);
      this.$store.commit("dialogs/setOligoelementsSpecific", true);
    },
  },
};
</script>

<style scoped></style>
